import { render } from "./fiscalData.vue?vue&type=template&id=06c02d1f&ts=true"
import script from "./fiscalData.vue?vue&type=script&lang=ts"
export * from "./fiscalData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__